import { Link } from "react-router-dom";
import { BUSINESS, NAV, whatsappLink } from "@/content/site";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--line)] bg-[var(--char)] pb-28 lg:pb-0" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/brand/ne-logo-mark.png" alt="NE Tool Repair logo" width="1075" height="570" className="h-14 w-auto mix-blend-lighten" loading="lazy" />
          <p className="mt-6 text-sm text-[var(--grey)] max-w-sm leading-relaxed">Independent power tool repair and refurbishment in {BUSINESS.area}.</p>
        </div>
        <nav className="md:col-span-4" aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)]">Pages</p>
          <ul className="mt-4 grid grid-cols-2 gap-y-3 gap-x-6 text-sm">
            {[...NAV, { label: "Request a Repair", to: "/request-a-repair" }, { label: "Privacy & Cookies", to: "/privacy" }].map((n) => (
              <li key={n.to}><Link to={n.to} className="text-[var(--grey)] hover:text-white transition-colors" data-testid={`footer-link-${n.to.replace(/\//g, "") || "home"}`}>{n.label}</Link></li>
            ))}
          </ul>
        </nav>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)]">WhatsApp</p>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="mt-4 block font-display font-extrabold text-3xl hover:text-[var(--red-hi)] transition-colors" data-testid="footer-whatsapp-link">{BUSINESS.whatsappDisplay}</a>
          <p className="mt-2 text-sm text-[var(--grey)]">Service area: {BUSINESS.area}</p>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-[var(--mute)]">
          <p>© {new Date().getFullYear()} NE Tool Repair. All rights reserved.</p>
          <p className="max-w-2xl md:text-right">NE Tool Repair is an independent repair business and is not affiliated with, authorised or endorsed by Milwaukee Tool. Brand names are used only to describe the tools we work on.</p>
        </div>
      </div>
    </footer>
  );
}
